import React, { useEffect, useState } from "react";
import { Button, Input, Panel } from "rsuite";
import { Image } from "react-bootstrap";

export const Home = () => {
  const [telefono] = useState("4442560850");
  const [message, setMessage] = useState("Hola");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768); // Initial check

  const sendMessage = () => {
    var anchor = document.createElement("a");
    anchor.href = `https://api.whatsapp.com/send?phone=${telefono}&text=${message}`;
    anchor.target = "_blank";
    anchor.click();
  };

  const constructMessage = (e) => {
    setMessage(
      `Hola mi nombre es ${e}, me encuentro interesado en la plataforma.`
    );
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Update on resize
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize); // Cleanup
    };
  }, []);

  const backgroundStyle = {
    backgroundImage: `url(${
      isMobile ? "/Images/backgroundMovil.jpg" : "/Images/background.jpg"
    })`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    minHeight: "100vh", // Ensure the background covers the full height
  };

  const panelStyle = {
    width: isMobile ? "85%" : "20%",
    margin: "0 auto",
    position: "absolute",
    top: isMobile ? "65%": "35%",
    left: isMobile ? "0%" : "25%",
    right: isMobile ? "0%" : "20%",
    backgroundColor: '#E1F1F5',
    opacity: '90%'
  };

  return (
    <div style={backgroundStyle}>
      <div
        style={panelStyle}
      >
        <Panel bordered shaded header="Envianos un mensaje">
          <div className="row">
            <div className="col">
              <Input
                onChange={(e) => constructMessage(e)}
                placeholder="Escribe tu nombre"
              ></Input>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <Input
                as="textarea"
                rows={2}
                value={message}
                onChange={(e) => setMessage(e)}
              ></Input>
            </div>
          </div>
          <br></br>
          <div className="row">
            <div className="col">
              <Button
                appearance="ghost"
                onClick={() => sendMessage()}
                size="sm"
                block
              >
                <Image
                  src="/Images/whatsapp.png"
                  style={{ height: "30px" }}
                ></Image>
                &nbsp; Enviar mensaje
              </Button>
            </div>
          </div>
        </Panel>
      </div>
    </div>
  );
};
